export { fetchJournalsSeoData } from './fetchJournalsSeoData'
export { normalizeJournalsSeoData } from './normalizeJournalsSeoData'
